<template>
    <div class="content-item flex align-items-center">
      <div class="content-item-label">
        <span class="red" v-if="JSON.parse(commonData[0].value) === '1'">*</span
        >{{ JSON.parse(commonData[1].value) || "疾病方向" }}
      </div>
      <!-- <el-select
        v-model="diseaseId"
        multiple
        filterable
        remote
        placeholder="请输入疾病方向"
        :remote-method="diseaseRemoteMethod"
        @change="writeChange"
        :loading="diseaseLoading"
      >
        <el-option
          v-for="item in diseaseOptions"
          :key="item.diseaseId"
          :label="item.diseaseName"
          :value="item.diseaseId"
        >
        </el-option>
      </el-select> -->
      <el-input
        placeholder="请输入疾病方向ID，多个用英文逗号隔开"
        v-model="contentDiseaseDirections"
      />
    </div>
  </template>
  
  <script>
  
  export default {
    name: "selectDisease",
    props: ["functionIds", "contentId", "commonData"],
    data() {
      return {
        // 关联症状疾病方向
        contentDiseaseDirections: '',
      };
    },
    methods: {}
  };
  </script>
  
  <style lang="scss" scoped></style>
  